"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var PageForwards_1 = __importDefault(require("./styledComponents/PageForwards"));
var PageBackwards_1 = __importDefault(require("./styledComponents/PageBackwards"));
var PagingResultsStatus_1 = __importDefault(require("./styledComponents/PagingResultsStatus"));
var PageSizeWrapper_1 = __importDefault(require("./styledComponents/PageSizeWrapper"));
var PageSizeLabel_1 = __importDefault(require("./styledComponents/PageSizeLabel"));
var PageSizeSelector_1 = __importDefault(require("./styledComponents/PageSizeSelector"));
var PageSelector_1 = __importDefault(require("./styledComponents/PageSelector"));
var PageSelectorPrefix_1 = __importDefault(require("./styledComponents/PageSelectorPrefix"));
var PageSelectorSuffix_1 = __importDefault(require("./styledComponents/PageSelectorSuffix"));
var PageSelectorWrapper_1 = __importDefault(require("./styledComponents/PageSelectorWrapper"));
var PageNavigation_1 = __importDefault(require("./styledComponents/PageNavigation"));
var Paging_meta_1 = require("./Paging.meta");
var mobx_1 = require("mobx");
var ButtonFlat_1 = __importDefault(require("../../base/ButtonFlat/ButtonFlat"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var Translate_1 = __importDefault(require("../Translate"));
var PageFirstButton_1 = __importDefault(require("./styledComponents/PageFirstButton"));
var PageLastButton_1 = __importDefault(require("./styledComponents/PageLastButton"));
var Paging = /** @class */ (function (_super) {
    __extends(Paging, _super);
    function Paging(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Paging_meta_1.PAGING_CATEGORY_KEY;
        _this.componentKey = Paging_meta_1.PAGING_COMPONENT_KEY;
        _this.currentIndex = 0;
        _this.pageSize = 10;
        _this.fireOnChange = function () {
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(_this.currentIndex, _this.pageSize);
            }
        };
        _this.handlePageBackward = function () {
            var pageBackward = _this.props.pageBackward;
            _this.currentIndex = Math.max(_this.currentIndex - _this.pageSize, 0);
            if (pageBackward) {
                pageBackward(_this.currentIndex);
            }
            _this.fireOnChange();
        };
        _this.handleFirstPage = function () {
            var pageFirst = _this.props.pageFirst;
            _this.currentIndex = 0;
            if (pageFirst) {
                pageFirst(_this.currentIndex);
            }
            _this.fireOnChange();
        };
        _this.handleLastPage = function () {
            var pageLast = _this.props.pageLast;
            _this.currentIndex = (_this.totalPages - 1) * _this.pageSize;
            if (pageLast) {
                pageLast(_this.currentIndex);
            }
            _this.fireOnChange();
        };
        _this.handlePageForward = function () {
            var pageForward = _this.props.pageForward;
            _this.currentIndex = _this.currentIndex + _this.pageSize;
            if (pageForward) {
                pageForward(_this.currentIndex);
            }
            _this.fireOnChange();
        };
        _this.handlePageSizeChange = function (items) {
            var pageSizeSelection = _this.props.pageSizeSelection;
            var item = mobx_1.isArrayLike(items) ? items[0] : items;
            var newPageSize = parseInt(item.value, 10);
            _this.pageSize = newPageSize;
            _this.currentIndex = 0;
            if (pageSizeSelection && pageSizeSelection.callback) {
                pageSizeSelection.callback(_this.pageSize, _this.currentIndex);
            }
            _this.fireOnChange();
        };
        _this.handlePageChange = function (items) {
            var pageSelection = _this.props.pageSelection;
            var item = mobx_1.isArrayLike(items) ? items[0] : items;
            var newPage = parseInt(item.value, 10) - 1;
            var newIndex = newPage * _this.pageSize;
            _this.currentIndex = newIndex;
            if (pageSelection && pageSelection.callback) {
                pageSelection.callback(newPage, _this.currentIndex);
            }
            _this.fireOnChange();
        };
        _this.pageSize = props.pageSize || _this.pageSize;
        _this.currentIndex = props.currentIndex || _this.currentIndex;
        return _this;
    }
    Paging.prototype.componentDidUpdate = function (previousProps) {
        var _a = this.props, pageSize = _a.pageSize, totalRows = _a.totalRows, currentIndex = _a.currentIndex;
        var pageSizeChanged = pageSize !== undefined && previousProps.pageSize !== pageSize;
        var totalRowsChanged = totalRows !== undefined && previousProps.totalRows !== totalRows;
        var currentIndexChanged = currentIndex !== undefined && previousProps.currentIndex !== currentIndex;
        if (pageSizeChanged || totalRowsChanged || currentIndexChanged) {
            this.currentIndex = !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(currentIndex) ? currentIndex : this.currentIndex;
            this.pageSize = pageSize || this.pageSize;
        }
    };
    Object.defineProperty(Paging.prototype, "pageBackwardsButton", {
        get: function () {
            var _a = this.props, _b = _a.pagingButtons, pagingButtons = _b === void 0 ? {} : _b, ariaControls = _a.ariaControls;
            var _c = pagingButtons.previous, previous = _c === void 0 ? {} : _c;
            var disabled = this.currentIndex <= 0;
            var enabledIconProps = previous.iconProps ? previous.iconProps : {
                asset: 'base.paging.leftArrow'
            };
            var disabledIconProps = previous.disabledIconProps || { asset: 'base.paging.leftArrowDisabled' };
            var iconProps = disabled ? disabledIconProps : enabledIconProps;
            var label = "Go to Previous page";
            var ariaLabel = this.translationContext ? this.translationContext.translate(label) : label;
            return (react_1.default.createElement(PageBackwards_1.default, null,
                react_1.default.createElement(ButtonFlat_1.default, { onClick: this.handlePageBackward, "aria-label": ariaLabel, disabled: disabled, iconProps: iconProps, "aria-controls": ariaControls }, !previous.hideLabel && react_1.default.createElement("span", { "aria-hidden": "true" }, "Previous"))));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "firstPageButton", {
        get: function () {
            var _a = this.props, _b = _a.pagingButtons, pagingButtons = _b === void 0 ? {} : _b, ariaControls = _a.ariaControls;
            var _c = pagingButtons.first, first = _c === void 0 ? {} : _c;
            var disabled = this.currentIndex === 0;
            var enabledIconProps = first.iconProps ? first.iconProps : {
                asset: 'base.paging.pagingFirstArrow'
            };
            var disabledIconProps = first.disabledIconProps || { asset: 'base.paging.pagingFirstArrowDisabled' };
            var iconProps = disabled ? disabledIconProps : enabledIconProps;
            var label = "Go to First page";
            var ariaLabel = this.translationContext ? this.translationContext.translate(label) : label;
            return (react_1.default.createElement(PageFirstButton_1.default, null,
                react_1.default.createElement(ButtonFlat_1.default, { onClick: this.handleFirstPage, "aria-label": ariaLabel, disabled: disabled, iconProps: iconProps, "aria-controls": ariaControls }, !first.hideLabel && react_1.default.createElement("span", { "aria-hidden": "true" }, "First"))));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "lastPageButton", {
        get: function () {
            var _a = this.props, _b = _a.pagingButtons, pagingButtons = _b === void 0 ? {} : _b, ariaControls = _a.ariaControls;
            var _c = pagingButtons.last, last = _c === void 0 ? {} : _c;
            var disabled = this.currentPage === this.totalPages;
            var enabledIconProps = last.iconProps ? last.iconProps : {
                asset: 'base.paging.pagingLastArrow'
            };
            var disabledIconProps = last.disabledIconProps || { asset: 'base.paging.pagingLastArrowDisabled' };
            var iconProps = disabled ? disabledIconProps : enabledIconProps;
            var label = "Go to Last page";
            var ariaLabel = this.translationContext ? this.translationContext.translate(label) : label;
            return (react_1.default.createElement(PageLastButton_1.default, null,
                react_1.default.createElement(ButtonFlat_1.default, { onClick: this.handleLastPage, "aria-label": ariaLabel, disabled: disabled, iconProps: iconProps, "aria-controls": ariaControls }, !last.hideLabel && react_1.default.createElement("span", { "aria-hidden": "true" }, "Last"))));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageForwardsButton", {
        get: function () {
            var _a = this.props, totalRows = _a.totalRows, _b = _a.pagingButtons, pagingButtons = _b === void 0 ? {} : _b, ariaControls = _a.ariaControls;
            var _c = pagingButtons.next, next = _c === void 0 ? {} : _c;
            var disabled = totalRows <= this.currentIndex + this.pageSize;
            var enabledIconProps = next.iconProps ? next.iconProps : {
                asset: 'base.paging.rightArrow'
            };
            var disabledIconProps = next.disabledIconProps || { asset: 'base.paging.rightArrowDisabled' };
            var iconProps = disabled ? disabledIconProps : enabledIconProps;
            var label = "Go to Next page";
            var ariaLabel = this.translationContext ? this.translationContext.translate(label) : label;
            return (react_1.default.createElement(PageForwards_1.default, null,
                react_1.default.createElement(ButtonFlat_1.default, { onClick: this.handlePageForward, "aria-label": ariaLabel, disabled: disabled, iconProps: iconProps, "aria-controls": ariaControls }, !next.hideLabel && react_1.default.createElement("span", { "aria-hidden": "true" }, "Next"))));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageSizeSelection", {
        get: function () {
            var _this = this;
            var _a = this.props, pageSizeSelection = _a.pageSizeSelection, ariaControls = _a.ariaControls;
            if (pageSizeSelection) {
                var label = pageSizeSelection.label, dropdownAssets = pageSizeSelection.dropdownAssets;
                var selectedItem = this.pageSizeOptions.find(function (option) { return option.value === _this.pageSize.toString(); });
                var ariaLabel = "";
                var defaultAriaLabel = "Records {aria:PerPage}";
                if (this.translationContext) {
                    ariaLabel = label ? this.translationContext.translate(label, this.placeholders) : this.translationContext.translate(defaultAriaLabel, this.placeholders);
                }
                else {
                    ariaLabel = label ? ksys_app_template_1.utils.replacePlaceholders({ values: this.placeholders, text: label }) : ksys_app_template_1.utils.replacePlaceholders({ values: this.placeholders, text: defaultAriaLabel });
                }
                return (react_1.default.createElement(PageSizeWrapper_1.default, { "aria-label": (selectedItem && selectedItem.value) + " " + ariaLabel },
                    react_1.default.createElement(PageSizeLabel_1.default, { "aria-hidden": "true" }, label),
                    react_1.default.createElement(PageSizeSelector_1.default, { dropdownAssets: dropdownAssets, ariaControls: ariaControls, onChange: this.handlePageSizeChange, selectedItem: selectedItem, items: this.pageSizeOptions })));
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageSizeOptions", {
        get: function () {
            var _a = this.props.pageSizeSelection, pageSizeSelection = _a === void 0 ? {} : _a;
            var options = pageSizeSelection.options;
            if (!options) {
                options = [this.pageSize];
            }
            return options.map(function (value) { return ({ value: value.toString(), label: value.toString() }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageSelectionSuffix", {
        get: function () {
            var suffix = this.props.pageSelection && this.props.pageSelection.suffix;
            if (this.translationContext && suffix) {
                return this.translationContext.translate(suffix, this.placeholders);
            }
            return suffix && ksys_app_template_1.utils.replacePlaceholders({ values: this.placeholders, text: suffix });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageSelectionAriaLabel", {
        get: function () {
            var ariaLabel = (this.props.pageSelection && this.props.pageSelection.ariaLabel) ? this.props.pageSelection.ariaLabel : 'Page {currentPage} of {totalPages}';
            if (this.translationContext && ariaLabel) {
                return this.translationContext.translate(ariaLabel, this.placeholders);
            }
            return ariaLabel && ksys_app_template_1.utils.replacePlaceholders({ values: this.placeholders, text: ariaLabel });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "dropdownAssets", {
        get: function () {
            return this.props.pageSelection && this.props.pageSelection.dropdownAssets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageSelection", {
        get: function () {
            var _this = this;
            var _a = this.props, pageSelection = _a.pageSelection, ariaControls = _a.ariaControls;
            if (pageSelection && pageSelection.enabled) {
                var prefix = pageSelection.prefix, suffix = pageSelection.suffix;
                var totalPages = this.totalPages;
                return (react_1.default.createElement(PageSelectorWrapper_1.default, { "aria-label": this.pageSelectionAriaLabel },
                    prefix && (react_1.default.createElement(PageSelectorPrefix_1.default, { "aria-hidden": "true" },
                        react_1.default.createElement(Translate_1.default, null, ksys_app_template_1.utils.replacePlaceholders({ values: this.placeholders, text: prefix })))),
                    react_1.default.createElement(PageSelector_1.default, { onChange: this.handlePageChange, selectedItem: this.pageOptions.find(function (option) { return option.value === _this.currentPage.toString(); }), items: this.pageOptions, ariaControls: ariaControls, dropdownAssets: this.dropdownAssets }),
                    suffix && (react_1.default.createElement(PageSelectorSuffix_1.default, { "aria-hidden": "true" }, this.pageSelectionSuffix))));
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "currentPage", {
        get: function () {
            var currentPage = Math.ceil((this.currentIndex + 1) / this.pageSize);
            return currentPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageOptions", {
        get: function () {
            var options = [];
            var totalPages = this.totalPages;
            for (var i = 1; i <= totalPages; i++) {
                var pageNumber = i.toString();
                options.push({
                    value: pageNumber,
                    label: pageNumber,
                });
            }
            return options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "totalPages", {
        get: function () {
            return Math.ceil(this.totalRows / this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "totalRows", {
        get: function () {
            return this.props.totalRows || 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "firstItem", {
        get: function () {
            return Math.min(this.totalRows, this.currentIndex + 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "lastItem", {
        get: function () {
            return Math.min(this.totalRows, this.currentIndex + this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "placeholders", {
        get: function () {
            return {
                firstItem: this.firstItem,
                lastItem: this.lastItem,
                totalRows: this.totalRows,
                currentPage: this.currentPage,
                totalPages: this.totalPages,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageNavigationOptions", {
        get: function () {
            return {
                'First': this.firstPageButton,
                'Previous': this.pageBackwardsButton,
                'Next': this.pageForwardsButton,
                'Last': this.lastPageButton,
                'PageSelection': this.pageSelection,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pageNavigation", {
        get: function () {
            var _this = this;
            var _a = this.props.layout, layout = _a === void 0 ? {} : _a;
            // default layout will not include first & last to manage backward compatibility where they did not exist before (breaks styling)
            var _b = layout.pageNavigationOrder, pageNavigationOrder = _b === void 0 ? ['Previous', 'PageSelection', 'Next'] : _b;
            return (react_1.default.createElement(PageNavigation_1.default, null, pageNavigationOrder.map(function (pageNavigationComponent) { return (react_1.default.createElement(react_1.Fragment, { key: pageNavigationComponent }, _this.pageNavigationOptions[pageNavigationComponent])); })));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "pagingResultsStatus", {
        get: function () {
            var _a = this.props.pagingLabelFormat, pagingLabelFormat = _a === void 0 ? '{firstItem} - {lastItem} / {totalRows}' : _a;
            return (react_1.default.createElement(PagingResultsStatus_1.default, { "aria-hidden": "true" },
                react_1.default.createElement(Translate_1.default, null, ksys_app_template_1.utils.replacePlaceholders({ text: pagingLabelFormat, values: this.placeholders }))));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Paging.prototype, "baseLayoutOptions", {
        get: function () {
            return {
                'PageSizeSelection': this.pageSizeSelection,
                'ResultStatus': this.pagingResultsStatus,
                'PageNavigation': this.pageNavigation,
            };
        },
        enumerable: true,
        configurable: true
    });
    Paging.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, _b = _a.layout, layout = _b === void 0 ? {} : _b;
        var _c = layout.baseOrder, baseOrder = _c === void 0 ? ['PageSizeSelection', 'ResultStatus', 'PageNavigation'] : _c;
        return (react_1.default.createElement(Wrapper_1.default, { className: className }, baseOrder.map(function (baseLayoutComponent) { return (react_1.default.createElement(react_1.Fragment, { key: baseLayoutComponent }, _this.baseLayoutOptions[baseLayoutComponent])); })));
    };
    __decorate([
        mobx_1.observable
    ], Paging.prototype, "currentIndex", void 0);
    __decorate([
        mobx_1.observable
    ], Paging.prototype, "pageSize", void 0);
    __decorate([
        mobx_1.observable
    ], Paging.prototype, "translationContext", void 0);
    __decorate([
        mobx_1.action
    ], Paging.prototype, "fireOnChange", void 0);
    __decorate([
        mobx_1.action
    ], Paging.prototype, "handlePageBackward", void 0);
    __decorate([
        mobx_1.action
    ], Paging.prototype, "handleFirstPage", void 0);
    __decorate([
        mobx_1.action
    ], Paging.prototype, "handleLastPage", void 0);
    __decorate([
        mobx_1.action
    ], Paging.prototype, "handlePageForward", void 0);
    __decorate([
        mobx_1.action
    ], Paging.prototype, "handlePageSizeChange", void 0);
    __decorate([
        mobx_1.action
    ], Paging.prototype, "handlePageChange", void 0);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageBackwardsButton", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "firstPageButton", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "lastPageButton", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageForwardsButton", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageSizeSelection", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageSizeOptions", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageSelectionSuffix", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageSelectionAriaLabel", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "dropdownAssets", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageSelection", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "currentPage", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageOptions", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "totalPages", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "totalRows", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "firstItem", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "lastItem", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "placeholders", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageNavigationOptions", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pageNavigation", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "pagingResultsStatus", null);
    __decorate([
        mobx_1.computed
    ], Paging.prototype, "baseLayoutOptions", null);
    Paging = __decorate([
        mobx_react_1.observer
    ], Paging);
    return Paging;
}(shared_1.ComponentBase));
exports.Paging = Paging;
exports.default = shared_1.InjectedStyledComponent(Paging, Paging_meta_1.PAGING_CATEGORY_KEY, Paging_meta_1.PAGING_COMPONENT_KEY);
